<div class="card mt-2">
    <div class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
        <div class="column" style="width: 100%;">
            <!-- QUE CAMBIE SEGUN EL PERIODO -->
            <h6 class="m-0">Evolutivo</h6>
            <div id="ev-chart" *ngIf="chartOptions">
                <apx-chart class="ev-chart-comp"
                [series]="chartOptions.series"
                [chart]="chartOptions.chart"
                [dataLabels]="chartOptions.dataLabels"
                [plotOptions]="chartOptions.plotOptions"
                [yaxis]="chartOptions.yaxis"
                [xaxis]="chartOptions.xaxis"
                [fill]="chartOptions.fill"
                [title]="chartOptions.title"
                ></apx-chart>
            </div>
        </div>
    </div>
</div>